import WebsiteInput from "./WebsiteView/WebsiteInput";
export default function EditWebsite() {
  return (
    <div
      className={`primary-card-background h-full shadow-2xl z-50 transition-transform duration-500 flex translate-x-0`}
    >
      <WebsiteInput />
    </div>
  );
}
